// Liens vers le site WordPress que l'application sait afficher elle-même : ils s'ouvrent
// dans un écran interne au lieu d'un nouvel onglet. Tout le reste (compte, fichiers, PDF,
// pages sans écran dans l'application, sites tiers) garde son lien d'origine.

const SITE_HOSTS = [
  'maison.cartedor.fr',
  'www.maison.cartedor.fr',
  'stage.maison.cartedor.fr',
  'cartedor.preprod.it',
  'club-cartedor.preprod.it',
];

// Contenus ouverts par leur identifiant (slug), résolu par /post/:path.
const CONTENT_PREFIXES = new Set(['recettes-club', 'articles', 'conseils', 'formations']);

// Listes et pages qui ont leur propre écran.
const PAGE_ROUTES = {
  'recette-heading': '/recipes',
  articles: '/articles',
  formations: '/formations',
  produits: '/products',
};

const hostOf = url => {
  try {
    return new URL(url).host;
  } catch {
    return null;
  }
};

const siteHosts = (apiUrl = process.env.REACT_APP_API_URL) => {
  const apiHost = apiUrl && hostOf(apiUrl);
  return apiHost ? [...SITE_HOSTS, apiHost] : SITE_HOSTS;
};

export const toAppRoute = (href, apiUrl) => {
  let url;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  if (!/^https?:$/.test(url.protocol) || !siteHosts(apiUrl).includes(url.host)) return null;

  const segments = url.pathname.split('/').filter(Boolean);
  // Lien absolu vers l'application elle-même.
  if (segments[0] === 'pwa') return `/${segments.slice(1).join('/')}`;
  if (/\.[\da-z]+$/i.test(url.pathname)) return null;

  if (segments.length === 1 && PAGE_ROUTES[segments[0]]) return PAGE_ROUTES[segments[0]];
  if (segments.length === 2 && CONTENT_PREFIXES.has(segments[0])) {
    return `/post/${encodeURIComponent(segments[1])}`;
  }
  return null;
};
